module.exports = __webpack_public_path__ + "img/position.1b04470c.png";